import { memo } from "react";
import { useLocalization } from "@fluent/react";

const ZEscrowItem = () => {
  const { l10n } = useLocalization();
  return (
    <button
      type="button"
      className="button--reset topMenu-link"
      onClick={() => {
        window.location.href = "/zescrow";
      }}
    >
      {l10n.getString("nav-zescrow-link", null, "ZEscrow")}
    </button>
  );
};

export default memo(ZEscrowItem);
